import * as tslib_1 from "tslib";
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { SessionsService } from '@services/session.service';
var MachineRobotVersionSource = /** @class */ (function () {
    function MachineRobotVersionSource(_sessions) {
        this._sessions = _sessions;
    }
    Object.defineProperty(MachineRobotVersionSource.prototype, "mapper", {
        get: function () {
            return this._sessions.mapper;
        },
        enumerable: true,
        configurable: true
    });
    MachineRobotVersionSource.prototype.get = function (qo) {
        return this._sessions.getByMachineId(this.machineId, qo);
    };
    return MachineRobotVersionSource;
}());
export { MachineRobotVersionSource };
var MachineRobotVersionsGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MachineRobotVersionsGridComponent, _super);
    function MachineRobotVersionsGridComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MachineRobotVersionsGridComponent.prototype, "machine", {
        set: function (value) {
            var svc = this._service;
            if (!svc ||
                !value ||
                svc.machineId === value.id) {
                return;
            }
            svc.machineId = value.id;
            this._refresh$.next();
        },
        enumerable: true,
        configurable: true
    });
    return MachineRobotVersionsGridComponent;
}(ODataGridComponent));
export { MachineRobotVersionsGridComponent };
